const debugOffline = () => localStorage.getItem('_debug_online') === "false";
if (debugOffline())
    console.warn("_debug_online is true and turns the offline endpoints to work in offline mode. This doesn't block the app from running 100% offline, but only offline featured client endpoints are affected.");
export const getOnline = () => {
    if (debugOffline())
        return false;
    return navigator.onLine;
};
